import request from '@/utils/request'

// 销售管理 - 分页
export function pagePromotionSales(query) {
  return request({
    url: '/biz/promotion/page',
    method: 'get',
    params: query
  })
}

// 销售管理 - 列表
export function listPromotionSales(query) {
  return request({
    url: '/biz/promotion/list',
    method: 'get',
    params: query
  })
}

// 销售管理 - 详情
export function getPromotionSales(data) {
  return request({
    url: '/biz/promotion/detail',
    method: 'get',
    params: data
  })
}

// 销售管理 - 新增（salesCode 由后端自动生成，前端不传）
export function addPromotionSales(data) {
  return request({
    url: '/biz/promotion/add',
    method: 'post',
    data: data
  })
}

// 销售管理 - 编辑
export function updatePromotionSales(data) {
  return request({
    url: '/biz/promotion/edit',
    method: 'post',
    data: data
  })
}

// 销售管理 - 删除（id 列表）
export function delPromotionSales(data) {
  return request({
    url: '/biz/promotion/delete',
    method: 'post',
    data: data
  })
}

// 下载二维码（返回 PNG blob；带 auth token）
export function downloadPromotionQrCode(query) {
  return request({
    url: '/biz/promotion/qr-code',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

// 推广统计（按销售×端 + 按天趋势 + 汇总）
export function getPromotionStats(data) {
  return request({
    url: '/biz/promotion/stats',
    method: 'post',
    data: data
  })
}
